const DEBUG_ANALYTICS_STORAGE_KEY = 'log_analytics_payload';

export abstract class BaseAnalyticsStore<T extends (...args: any[]) => any> {
  abstract readonly _analyticsTargetName: string;
  abstract sendEvent: T;

  sendWithLog(...args: Parameters<T>) {
    if (localStorage.getItem(DEBUG_ANALYTICS_STORAGE_KEY) !== null) {
      // eslint-disable-next-line no-console
      console.log(this._analyticsTargetName, ...args);
    }

    this.sendEvent(...args);
  }
}
